import { gql } from "@apollo/client";

export const GET_OVERSTAY_FEES_REPORT = gql`
  query (
    $operatorId: Int!
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $transactionStatus: String
    $paymentId: String
    $lockerIds: [Int]
    $mobileNumber: String
    $waybillNumber: String
    $paymentCurrency: String
    $doorSizeId: Int
  ) {
    overstayFees(
      operatorId: $operatorId
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      transactionStatus: $transactionStatus
      paymentId: $paymentId
      lockerIds: $lockerIds
      mobileNumber: $mobileNumber
      waybillNumber: $waybillNumber
      paymentCurrency: $paymentCurrency
      doorSizeId: $doorSizeId
    ) {
      packageId
      packageDate
      packageStateNo
      transactionFee
      transactionId
      duplicate
      paymentDate
      paymentId
      paymentCurrency
      lockerId
      lockerName
      paymentAmount
      recipientMobile
      waybillNumber
      senderMobile
      partnerAgentMobile
      hours
      serviceType
      status
      excessFee
      partnerAgentId
      userAccountId
      userId
      doorSize
      __typename
    }
  }
`;

export const GET_OVERSTAY_FEES_SUMMARY_REPORT = gql`
  query (
    $operatorId: Int!
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $lockerIds: [Int]
  ) {
    lockerPackageSummary(
      operatorId: $operatorId
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      lockerIds: $lockerIds
    ) {
      lockerId
      lockerName
      paymentCurrency
      earliestPackage
      latestPackage
      packages
      totalPayments
      percentPerLockerPackages
      percentPerLockerPayments
      __typename
    }
  }
`;

// CALL ONLY IF SELECTED LOCKER_ID IS AN EMPTY ARRAY
export const GET_AGGREGATE_OVERSTAY_FEES_REPORT = gql`
  query (
    $operatorId: Int!
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $transactionStatus: String
    $paymentId: String
    $lockerIds: [Int]
    $mobileNumber: String
    $waybillNumber: String
    $paymentCurrency: String
    $doorSizeId: Int
  ) {
    aggregateOverstayFees(
      operatorId: $operatorId
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      transactionStatus: $transactionStatus
      paymentId: $paymentId
      lockerIds: $lockerIds
      mobileNumber: $mobileNumber
      waybillNumber: $waybillNumber
      paymentCurrency: $paymentCurrency
      doorSizeId: $doorSizeId
    ) {
      lockerId
      # lockerName
      paymentCurrency
      serviceType
      status
      packageStateNo
      totalTransactions
      totalPaymentAmount
      totalTransactionFee
      totalExcessFee
      avgHours
      minPackageDate
      maxPackageDate
      duplicateCount
      hasDuplicates
      percentOfTotalTransactions
      percentOfTotalAmount
      doorSize
    }
  }
`;

// experimental monthly overstay fee breakdown
export const MONTHLY_OVERSTAY_FEES_REPORT = gql`
  query (
    $operatorId: Int!
    $dateStart: String!
    $dateEnd: String!
    $transactionStatus: String
    $paymentId: String
    $lockerIds: [Int]
    $mobileNumber: String
    $waybillNumber: String
    $paymentCurrency: String
  ) {
    monthlyOverstayFees(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      transactionStatus: $transactionStatus
      paymentId: $paymentId
      lockerIds: $lockerIds
      mobileNumber: $mobileNumber
      waybillNumber: $waybillNumber
      paymentCurrency: $paymentCurrency
    ) {
      paymentMonth
      paymentMonthName
      packageId
      partnerAgentId
      packageDate
      packageStateNo
      serviceType
      lockerId
      lockerName
      transactionId
      paymentDate
      transactionDate
      waybillNumber
      transactionFee
      packagePrice
      excessFee
      paymentAmount
      paymentCurrency
      recipientMobile
      senderMobile
      partnerAgentMobile
      hours
      status
      duplicate
      totalMonthAmount
      totalMonthTransactions
    }
  }
`;

export const COUNT_OVERSTAY_DATA = gql`
  query (
    $operatorId: Int!
    $dateStart: String!
    $dateEnd: String!
    $paymentCurrency: String
  ) {
    overstayFeesCount(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      paymentCurrency: $paymentCurrency
    )
  }
`;
